declare var loadLauncher: any;

import { Component, Input, OnInit } from '@angular/core';
import { NavbarService } from './primary-nav.service';
import { MessageService } from '../shared/message.service';
import { MessageType } from '../shared/messageType';
import { environment } from '../../environments/environment';
import { SecurityService } from '../shared/security.service';
import { ClaimsService } from '../shared/claims.service';
import { getAlertMessage } from '../shared/api-loaders';
import { UserCustomerService } from '../users/services/user-customer.service';
import { CustomerSettings } from '../users/models/CustomerSettings';
import { CustomerSupportService } from '../customer-support/services/customer-support.service';
import { forkJoin } from 'rxjs';
import { ModalService } from '../shared/modal.service';
import { CustomerSelectionModalDialogComponent } from '../customer-support/customer-selection-modal/customer-selection-modal-dialog.component';
import { LauncherService } from '../shared/launcher.service';
import { ToggleService } from '../shared/toggle/toggle.service';
import { Router } from '@angular/router';

@Component({
    selector: 're-primary-nav',
    templateUrl: './primary-nav.component.html',
    styleUrls: ['./primary-nav.component.scss'],
    standalone: false
})
export class PrimaryNavComponent implements OnInit {

  userMenuCollapsed: boolean;
  appMenuCollapsed: boolean;
  toggleButton: string;
  fullName: string;

  @Input()
  isAuthenticated: boolean;

  changePasswordUrl: string;
  isEctUserEmployee = false;
  isEctAdminEmployee = false;
  isUserManagementAdmin = false;
  isUserLocationLimitedAdmin = false;
  isMapping = false;
  isCorporateLimitedAdmin = false;
  showMyProfile: boolean = false;
  isServiceLogAdmin = false;
  isResDocMigrateUser = false;
  isProfileSyncUser = false;
  isSnfLegacyListUser = false;
  isFederatedUser: boolean;
  isEctReadOnlyUser = false;
  isKeycloakListUser = false;
  isImportUsers = false;
  isDuoCustomer = false;
  isIdpAdmin = false;
  canManageSessions = false;

  // TODO cdrouin reslove hard-coding, needed for immediate release.
  // showEnvironmentConfigTool = environment.showEnvConfigTool;
  showEnvironmentConfigTool = true;
  isTokenManagerUser: boolean;
  isReportsUser: boolean;
  isManageIPUser: boolean;
  isManageRulesUser: boolean;
  isManage2FactorAuthentication: boolean;
  customerSettings: CustomerSettings;




  showLauncher() {

    const debugLauncher = false;

    var apiURL = `${environment.adminToolServiceUrl}/api/idm/components/app-switcher`;
    var domSelector = '.navbar-header';

    if (!debugLauncher) {

      var head = document.getElementsByTagName("head")[0];
      var script = document.createElement("script");

      script.src = environment.appswitcherUrl+"?v=1.0.0";

      script.onload = () => {
        loadLauncher(domSelector, apiURL, null, null, false,"include");

      };
      head.appendChild(script);
    }
    else {
      loadLauncher(domSelector, apiURL, null, null, false, "include");
    }


  }
  constructor(public nav: NavbarService,
    private messages: MessageService,
    private claimsService: ClaimsService,
    private securityService: SecurityService,
	    public customerSettingsService: UserCustomerService,
    private customerSupportService: CustomerSupportService,
    private modalService: ModalService,
    private launcherService: LauncherService,
    private toggleService: ToggleService,
    private router: Router
  ) {

    this.securityService.loadUserInfoFromClaims();
    this.securityService.isCanViewAnyCustomer().subscribe(isViewCustomer => {
      if (this.securityService.skipServices()) //urls like logout need to just logout
        return;
      var customerSelected = this.customerSupportService.isCustomerSelected();
      this.isViewCustomer = isViewCustomer;
      if (!isViewCustomer || (isViewCustomer && customerSelected)) {

        this.customerSettingsService.getSettings().subscribe((x) => {
          this.customerSettings = x;
        })
      }

    })

    // this.fullName = this.oktaAuth.getUser();
    //this.changePasswordUrl = environment.baseUrl.split('/oauth2')[0] + '/enduser/settings'; //add it back when needed
    try {
      this.showMyProfile = JSON.parse(environment.showMyProfile);
    } catch (e) {
    }
  }


  navigateHome() {
    this.securityService.navigateToHome();
  }


  async ngOnInit() {
    this.appMenuCollapsed = false;
    this.userMenuCollapsed = false;

    this.isEctAdminEmployee = false;
    this.isEctUserEmployee = false;
    this.isUserManagementAdmin = false;
    this.isUserLocationLimitedAdmin = false;
    this.isMapping = false;
    this.isCorporateLimitedAdmin = false;
    this.isServiceLogAdmin = false;
    this.isFederatedUser = false;
    this.isTokenManagerUser = false;
    this.isReportsUser = false;
    this.isManageIPUser = false;
    this.isManageRulesUser = false;
    this.isEctReadOnlyUser = false;
    this.isManage2FactorAuthentication = false;

    if (this.securityService.skipServices()) //urls like logout need to just logout
      return;

    this.isDuoCustomer = await this.securityService.isDUOFederated();

    if (this.isAuthenticated) {
      // Load toggles in a non-blocking way; failures should not prevent nav role setup
      this.toggleService.get().subscribe({
        next: (toggles) => {
          if (toggles && toggles.launcherEnabled) {
            this.showLauncher();
          }
        },
        error: (err) => {
          console.warn('Toggles load failed; continuing without launcher.', getAlertMessage(err).message);
        }
      });

      this.fullName = this.claimsService.getName();
      this.securityService.isEcdAdmin().subscribe(x => this.isEctAdminEmployee = x);
      this.securityService.isEctUser().subscribe(x => this.isEctUserEmployee = x);
      this.securityService.isUserManagementAdmin().subscribe(x => this.isUserManagementAdmin = x);
      this.securityService.isUserLocationLimitedAdmin().subscribe(x => this.isUserLocationLimitedAdmin = x);
      this.securityService.isCorporateLimitedAdmin().subscribe(x => this.isCorporateLimitedAdmin = x);
      this.securityService.isServiceLogAdmin().subscribe(x => this.isServiceLogAdmin = x);
      this.securityService.isResDocMigrateUser().subscribe(x => this.isResDocMigrateUser = x);
      this.securityService.isProfileSyncUser().subscribe(x => this.isProfileSyncUser = x);
      this.securityService.isSnfLegacyListUser().subscribe(x => this.isSnfLegacyListUser = x);
      this.securityService.isFederatedUser().subscribe(x => this.isFederatedUser = x);
      this.securityService.isTokenManagerUser().subscribe(x => this.isTokenManagerUser = x);
      this.securityService.isReportsUser().subscribe(x => this.isReportsUser = x);
      this.securityService.isManageIPUser().subscribe(x => this.isManageIPUser = x, err => console.error(getAlertMessage(err).message));
      this.securityService.isManageRulesUser().subscribe(x => this.isManageRulesUser = x, err => console.error(getAlertMessage(err).message));
      this.securityService.isManage2FactorAuthentication().subscribe(x => this.isManage2FactorAuthentication = x, err => console.error(getAlertMessage(err).message));

      this.securityService.isEctReadOnlyUser().subscribe(x => this.isEctReadOnlyUser = x);
      this.securityService.isKeycloakListUser().subscribe(x => this.isKeycloakListUser = x);
      this.securityService.isImportUsers().subscribe(x => this.isImportUsers = x);
      this.securityService.isMapping().subscribe(x => this.isMapping = x, err => console.error(getAlertMessage(err).message));
      this.securityService.isIdpAdmin().subscribe(x => this.isIdpAdmin = x);
      this.securityService.canManageSessions().subscribe(x => this.canManageSessions = x);


      let $obs = forkJoin({
        isCustomerAdmin: this.securityService.isUserManagementCorporateAdmin()
      });
      $obs.subscribe(x => {
        this.isCustomerAdmin = x.isCustomerAdmin

        if (this.isViewCustomer && x.isCustomerAdmin) {
          let selectedCustomer = this.customerSupportService.getSelectedCustomer();
          if (selectedCustomer)
            this.selectedCustomer = selectedCustomer.accountName
        }
      })


    }



  }
  isCustomerAdmin = false;
  isViewCustomer= false;
  changeCustomer() {
    let dialog = CustomerSelectionModalDialogComponent.show(this.modalService);

    dialog.component.navigateToHomeOnCancel = false;
  }

  selectedCustomer = "";

  logout() {
    // will be handled by app.component
    this.messages.send(MessageType.Logout);
  }
  closeNavs() {
    this.userMenuCollapsed = false;
    this.appMenuCollapsed = false;
  }
  toggleNavs(toggleButton) {
    if (toggleButton == 'userMenu') {
      this.userMenuCollapsed = !this.userMenuCollapsed;
      this.appMenuCollapsed ? this.appMenuCollapsed = !this.appMenuCollapsed : this.appMenuCollapsed;
    } else {
      this.appMenuCollapsed = !this.appMenuCollapsed;
      this.userMenuCollapsed ? this.userMenuCollapsed = !this.userMenuCollapsed : this.userMenuCollapsed;
    }
  }
  get checkForMappingSeperator() {
    return this.isMapping && (this.isCustomerAdmin || this.isManageIPUser || this.isManageRulesUser || this.isManage2FactorAuthentication);
	}
}
